__webpack_require__.p = "/reports-translations/onboarding/";